import { render, staticRenderFns } from "./EmailRespondersView.vue?vue&type=template&id=69e55bde&"
import script from "./EmailRespondersView.vue?vue&type=script&lang=js&"
export * from "./EmailRespondersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e55bde')) {
      api.createRecord('69e55bde', component.options)
    } else {
      api.reload('69e55bde', component.options)
    }
    module.hot.accept("./EmailRespondersView.vue?vue&type=template&id=69e55bde&", function () {
      api.rerender('69e55bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/email/EmailRespondersView.vue"
export default component.exports